module.exports = require("@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform");